import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DealsService } from "../../../../auth/service/deals.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from "moment/moment";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { IDeal } from "../../../../auth/models/deal-inferface";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ListService } from "../../../../auth/service/list.service";
import { DatepickrComponent } from "../../../../layout/components/datepickr/datepickr.component";
import { IFigure } from "app/auth/models/figures";
import { ICustomer, ICustomerAddressList, ICustomerReferentList } from "../../../../modules/customer/customer.interface";

@Component({
  selector: "app-deals-edit",
  templateUrl: "./deals-edit.component.html",
  styleUrls: ["./deals-edit.component.scss"],
})
export class DealsEditComponent implements OnInit {
  @ViewChildren(DatepickrComponent) datePicker: QueryList<DatepickrComponent>; //Prendiamo cosi tutti gli input date per eseguire il reset
  public contentHeader: IContentHeader;
  public activeTab: string = "deal_detail";
  public typeDeal: string = null;
  public deal: any = null;
  public dealId: any = null;
  public isTaskDeal: boolean = false;
  public isTimeMaterialDeal: boolean = false;
  public isDetailSectionCompleted: boolean = true;
  public isThereDiscount: boolean = false; //True if there is a discount in the datatable box_2
  public formGroupDetail: FormGroup;
  public formGroupTask: FormGroup;
  public formGroupTimeMaterial: FormGroup;
  public formGroupBoxes: FormGroup;
  public employees_list: any = [];
  public customers_list: ICustomer[] = [];
  public filtered_customers_site_list: any = [];
  public filtered_referents_list: any = [];
  public customers_site_list: ICustomerAddressList[] = [];
  public figures_list: IFigure[] = [];
  public commercial_list: any = [];
  public referents_list: ICustomerReferentList[] = [];
  public isMobile: boolean = false;
  public total_deal: number = 0;
  public total_discounted_deal: number = 0;
  public employees_list_datatable: any = []; //Contains the selected employees from the detail section
  public taskTablesRows: any = [];
  public timeMaterialTablesRows: any = [];
  public billingFrequencyList: Array<string> = [];
  public dealDocument: any; //Variable for the upload of the document
  public fileName: any = null;
  public completedFileUpload: boolean = false;
  public selectedRowIndex: any = null;
  public columnTableTask: any = {
    //Object for back-end tells which columns to show in the generated document
    activity_name: true,
    contract_duration: true,
    months_number: true,
    monthly_canon: true,
    employee_name: false,
    daily_rate: false,
    line_amount: false,
    discount: false,
  };
  public columnTableTimeMaterial: any = {
    //Object for back-end tells which columns to show in the generated document
    figure_id: false,
    period: true,
    total_effort: true,
    daily_rate: true,
    employee_name: false,
    line_amount: false,
    discount: false,
  };
  public toggleModalAdd: boolean = false;
  public showErrors: boolean = false;

  constructor(
    public _formBuilder: FormBuilder,
    public _userService: UserService,
    public _customerService: CustomerService,
    public _utilService: UtilsService,
    private _changeDetectorRef: ChangeDetectorRef,
    public _figureService: UserFigureService,
    public _dealService: DealsService,
    private router: Router,
    private _deviceService: DeviceDetectorService,
    public _authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastrService,
    private _listService: ListService,
    public _modalService: NgbModal,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.params.subscribe((params) => {
      this.dealId = params.id;
    });
    this.formGroupDetail = this._formBuilder.group({
      type: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
      customer: new FormControl(null, [Validators.required]),
      office_site: new FormControl(null, [Validators.required]),
      referent_id: new FormControl(null),
      commercial: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      object: new FormControl(italian.data.OFFER_OBJCET, [Validators.required, Validators.maxLength(255)]),
      employee: new FormControl(null, [Validators.required]),
      start_date: new FormControl(null, [Validators.required]),
      end_date: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      tranche_number: new FormControl(null, [Validators.required]),
    });
    this.formGroupTask = this._formBuilder.group({
      activity_name: new FormControl(null),
      contract_duration: new FormControl(null),
      months_number: new FormControl(null),
      monthly_canon: new FormControl(null),
      employee_name: new FormControl(null),
      employee_hash: new FormControl([]),
      daily_rate: new FormControl(null),
      line_amount: new FormControl(null),
      discount: new FormControl(null),
    });
    this.formGroupTimeMaterial = this._formBuilder.group({
      figure_id: new FormControl(null),
      figure_name: new FormControl(null),
      period: new FormControl(null),
      total_effort: new FormControl(null),
      daily_rate: new FormControl(null),
      employee_name: new FormControl(null),
      employee_hash: new FormControl([]),
      line_amount: new FormControl(null),
      discount: new FormControl(null),
    });
    this.formGroupBoxes = this._formBuilder.group({
      box_1: new FormControl(null, [Validators.required]),
      box_2: new FormControl(null, [Validators.required]),
      box_3: new FormControl(null, [Validators.required]),
      box_4: new FormControl(null, [Validators.required]),
      box_5: new FormControl(null, [Validators.required]),
      box_6: new FormControl(null, [Validators.required]),
      box_7: new FormControl(null, [Validators.required]),
      box_8: new FormControl(null, [Validators.required]),
    });
    this.isMobile = this._deviceService.isMobile();
  }

  async ngOnInit() {
    if (!this._authService.hasCapability("edit_deal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this._userService.allUserList.length < 1) {
      await this._userService.getAllUsers().then(() => {
        this.employees_list = this._userService.allUserList.filter((user) => user.type_code !== "ex-employee");
      });
    } else {
      this.employees_list = this._userService.allUserList.filter((user) => user.type_code !== "ex-employee");
    }
    
    this.commercial_list = this.employees_list.filter((user: any) => user.role === "Direzione" || user.role === "Commerciale");
    this.customers_list = await this._customerService.getCustomers();
    this.customers_list = this.customers_list.sort((a, b) => (a.name > b.name ? 1 : -1));
    this.referents_list = await this._customerService.getReferents();
    this.customers_site_list = await this._customerService.getAddresses();
    this.figures_list = await this._figureService.getList();
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    await this.loadDeal();
    this._utilService.hideLoading();
  }

  async loadDeal() {
    this.taskTablesRows = [];
    this.timeMaterialTablesRows = [];
    await this._dealService
      .getDeal(this.dealId)
      .then((response: any) => {
        this.deal = response;
        this.typeDeal = this.deal.deal_type; //We save the type of the deal
        this.isTaskDeal = this.typeDeal === "Task";
        this.isTimeMaterialDeal = this.typeDeal === "Time Material";
        //Here we change the referent's list and the site
        this.filtered_referents_list = this.referents_list.filter((r) => r.client_id === this.deal.client.id);
        this.filtered_customers_site_list = this.customers_site_list.filter((s) => s.client && s.client?.id === this.deal.client.id);
        //Here we push the employees of the deal in the ng-select of the formGroupDetail
        let employees: any = [];
        this.deal?.employees.map((employee: any) => {
          if (this.employees_list.find((emp) => emp.hash === employee.hash)) {
            employees.push(employee.hash);
          }
        });
        this.formGroupDetail.patchValue({
          type: this.deal?.deal_type,
          customer: this.deal?.client.id,
          office_site: this.deal?.client_site.id,
          referent_id: this.deal?.referent.id,
          commercial: this.deal?.commercial.hash,
          employee: employees,
          object: this.deal?.object,
          name: this.deal?.name,
          start_date: moment(this.deal?.start_date).format("YYYY-MM-DD"),
          end_date: moment(this.deal?.end_date).format("YYYY-MM-DD"),
          billing_frequency: this.deal?.billing_frequency,
          tranche_number: this.deal?.tranche_number,
        });
        this.formGroupBoxes.patchValue({
          box_1:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_1 ? this._utilService.stripHTML(this.deal?.deal_document?.box_1.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
          box_2:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_2 ? this._utilService.stripHTML(this.deal?.deal_document?.box_2.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
          box_3:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_3 ? this._utilService.stripHTML(this.deal?.deal_document?.box_3.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
          box_4:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_4 ? this._utilService.stripHTML(this.deal?.deal_document?.box_4.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
          box_5:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_5 ? this._utilService.stripHTML(this.deal?.deal_document?.box_5.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
          box_6:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_6 ? this._utilService.stripHTML(this.deal?.deal_document?.box_6.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
          box_7:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_7 ? this._utilService.stripHTML(this.deal?.deal_document?.box_7.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
          box_8:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_8 ? this._utilService.stripHTML(this.deal?.deal_document?.box_8.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, "\"") : null,
        });
        if (this.deal.deal_document.table && this.deal.deal_document.table.length > 0) {
          //Rimozione dei duplicati
          if (this.formGroupDetail.value.type && this.formGroupDetail.value.type === "Time Material") {
            this.deal.deal_document.table = this.deal.deal_document.table.filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) => t.line_amount === value.line_amount && t.daily_rate === value.daily_rate && t.employee_hash === value.employee_hash && t.figure_name === value.figure_name && t.period === value.period,
                ),
            );
          }
          if (this.formGroupDetail.value.type && this.formGroupDetail.value.type === "Task") {
            this.deal.deal_document.table = this.deal.deal_document.table.filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.line_amount === value.line_amount &&
                    t.daily_rate === value.daily_rate &&
                    t.employee_hash === value.employee_hash &&
                    t.activity_name === value.activity_name &&
                    t.monthly_canon === value.monthly_canon,
                ),
            );
          }
          //check if we have element in row
          //We patch the form groups with the first element in the array also we take which columns to show
          if (this.isTaskDeal) {
            this.formGroupTask.patchValue({
              activity_name: this.deal?.deal_document?.table[0]?.activity_name ? this.deal?.deal_document?.table[0]?.activity_name : null,
              contract_duration: this.deal?.deal_document?.table[0]?.contract_duration ? this.deal?.deal_document?.table[0]?.contract_duration : null,
              months_number: this.deal?.deal_document?.table[0]?.months_number ? this.deal?.deal_document?.table[0]?.months_number : null,
              monthly_canon: this.deal?.deal_document?.table[0]?.monthly_canon ? this.deal?.deal_document?.table[0]?.monthly_canon : null,
              employee_name: this.deal?.deal_document?.table[0]?.employee_name ? this.deal?.deal_document?.table[0]?.employee_name : null,
              employee_hash: this.deal?.deal_document?.table[0]?.employee_hash ? this.deal?.deal_document?.table[0]?.employee_hash : null,
              daily_rate: this.deal?.deal_document?.table[0]?.daily_rate ? this.deal?.deal_document?.table[0]?.daily_rate : null,
              line_amount: this.deal?.deal_document?.table[0]?.line_amount ? this.deal?.deal_document?.table[0]?.line_amount : null,
              discount: this.deal?.deal_document?.table[0]?.discount ? this.deal?.deal_document?.table[0]?.discount : null,
            });
            if (!!this.deal.deal_document.table_columns) {
              this.columnTableTask = this.deal?.deal_document?.table_columns;
            }
          } else {
            this.formGroupTimeMaterial.patchValue({
              figure_id: this.deal?.deal_document?.table[0]?.figure_id ? this.deal?.deal_document?.table[0]?.figure_id : null,
              figure_name: this.deal?.deal_document?.table[0]?.figure_name ? this.deal?.deal_document?.table[0]?.figure_name : null,
              period: this.deal?.deal_document?.table[0]?.period ? this.deal?.deal_document?.table[0]?.period : null,
              total_effort: this.deal?.deal_document?.table[0]?.total_effort ? this.deal?.deal_document?.table[0]?.total_effort : null,
              daily_rate: this.deal?.deal_document?.table[0]?.daily_rate ? this.deal?.deal_document?.table[0]?.daily_rate : null,
              employee_name: this.deal?.deal_document?.table[0]?.employee_name ? this.deal?.deal_document?.table[0]?.employee_name : null,
              employee_hash: this.deal?.deal_document?.table[0]?.employee_hash ? this.deal?.deal_document?.table[0]?.employee_hash : null,
              line_amount: this.deal?.deal_document?.table[0]?.line_amount ? this.deal?.deal_document?.table[0]?.line_amount : null,
              discount: this.deal?.deal_document?.table[0]?.discount ? this.deal?.deal_document?.table[0]?.discount : null,
            });
            if (!!this.deal.deal_document.table_columns) {
              this.columnTableTimeMaterial = this.deal?.deal_document?.table_columns;
            }
          }
          this.deal?.deal_document?.table.map((item: any) => {
            if (this.isTaskDeal) {
              if (item) {
                this.taskTablesRows.push({
                  activity_name: item?.activity_name,
                  contract_duration: item?.contract_duration,
                  months_number: item?.months_number,
                  monthly_canon: item?.monthly_canon,
                  line_amount: item?.line_amount,
                  employee_name: item?.employee_name,
                  employee_hash: item?.employee_hash,
                  daily_rate: item?.daily_rate,
                  discount: item?.discount,
                });
              }
            } else {
              if (item) {
                this.timeMaterialTablesRows.push({
                  figure_id: item?.figure_id,
                  figure_name: item?.figure_name,
                  period: item?.period,
                  total_effort: item?.total_effort,
                  line_amount: item?.line_amount,
                  employee_name: item?.employee_name,
                  employee_hash: item?.employee_hash,
                  daily_rate: item?.daily_rate,
                  discount: item?.discount,
                });
              }
            }
          });
        } else {
          //If we don't find any element in row we push a default row
          this.addRow();
        }

        //Here we fill the total
        this.calculateTotalDealAmount();
        //Here we fill the array employee for the datatable ng-select
        this.fillDataTableEmployeeArray();
        this.contentHeader = {
          headerTitle: this.isTaskDeal ? "DETAIL_OFFER_TASK" : "DETAIL_OFFER_TIME_MATERIAL",
          actionButton: false,
          breadcrumb: {
            type: "",
            links: [
              {
                name: "Home",
                isLink: true,
                link: "/",
              },
              {
                name: "MENU.DEALS",
                isLink: true,
                link: "/dashboard/deals/list",
              },
              {
                name: this.isTaskDeal ? "DETAIL_OFFER_TASK" : "DETAIL_OFFER_TIME_MATERIAL",
                isLink: false,
              },
            ],
          },
        };
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          this.router.navigateByUrl("/dashboard/deals/list");
          this._utilService.showToastrError("NOT_AUTHORIZED");
          return false;
        }
      });
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroupDetail.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupDetail.controls[field_name].status === "INVALID" && this.formGroupDetail.controls[field_name].touched;
    }
  }

  async modalOpen(modalBasic, selectedRow: any, index: number) {
    if (selectedRow) {
      if (this.isTaskDeal) {
        this.formGroupTask.patchValue({
          activity_name: selectedRow.activity_name ? selectedRow.activity_name : null,
          contract_duration: selectedRow.contract_duration ? selectedRow.contract_duration : null,
          months_number: selectedRow.months_number ? selectedRow.months_number : null,
          monthly_canon: selectedRow.monthly_canon ? selectedRow.monthly_canon : null,
          employee_name: selectedRow.employee_name ? selectedRow.employee_name : null,
          employee_hash: selectedRow.employee_hash ? selectedRow.employee_hash : null,
          daily_rate: selectedRow.daily_rate ? selectedRow.daily_rate : null,
          line_amount: selectedRow.line_amount ? selectedRow.line_amount : null,
          discount: selectedRow.discount ? selectedRow.discount : null,
        });
      } else {
        this.formGroupTimeMaterial.patchValue({
          figure_id: selectedRow.figure_id ? selectedRow.figure_id : null,
          figure_name: selectedRow.figure_name ? selectedRow.figure_name : null,
          period: selectedRow.period ? selectedRow.period : null,
          total_effort: selectedRow.total_effort ? selectedRow.total_effort : null,
          daily_rate: selectedRow.daily_rate ? selectedRow.daily_rate : null,
          employee_name: selectedRow.employee_name ? selectedRow.employee_name : null,
          employee_hash: selectedRow.employee_hash ? selectedRow.employee_hash : null,
          line_amount: selectedRow.line_amount ? selectedRow.line_amount : null,
          discount: selectedRow.discount ? selectedRow.discount : null,
        });
      }
      this.selectedRowIndex = index;
      this._modalService.open(modalBasic, {
        size: "md",
        centered: true,
        keyboard: false,
        backdrop: false,
      });
    }
  }

  //Function for add a new row in the datatable box_2
  addRow(hash_employee: string = null) {
    if (this.isTaskDeal) {
      //Here we set the values null but someone we will take from the first element if is present
      this.taskTablesRows.push({
        activity_name: null,
        contract_duration: this.formGroupTask.value.contract_duration ? this.formGroupTask.value.contract_duration : null,
        months_number: this.formGroupTask.value.months_number ? this.formGroupTask.value.months_number : null,
        monthly_canon: null,
        employee_name: hash_employee ? this.employees_list.find((emp) => emp.hash === hash_employee).complete_name : null,
        employee_hash: hash_employee ? hash_employee : null,
        daily_rate: null,
        line_amount: null,
        discount: null,
      });
    }
    if (this.isTimeMaterialDeal) {
      //Here we set the values null but someone we will take from the first element if is present
      this.timeMaterialTablesRows.push({
        figure_id: null,
        figure_name: null,
        period: this.formGroupTimeMaterial.value.period ? this.formGroupTimeMaterial.value.period : null,
        total_effort: this.formGroupTimeMaterial.value.total_effort ? this.formGroupTimeMaterial.value.total_effort : null,
        daily_rate: null,
        employee_name: hash_employee ? this.employees_list.find((emp) => emp.hash === hash_employee).complete_name : null,
        employee_hash: hash_employee ? hash_employee : null,
        line_amount: null,
        discount: null,
      });
      this.timeMaterialTablesRows = this.timeMaterialTablesRows.filter((i) => i);
      this._changeDetectorRef.detectChanges();
    }
  }

  editRow() {
    if (this.isTaskDeal) {
      this.taskTablesRows[this.selectedRowIndex] = this.formGroupTask.value;
      this.taskTablesRows[this.selectedRowIndex].employee_name = this.employees_list.find((emp) => emp.hash === this.formGroupTask.value.employee_hash).complete_name;
    } else {
      //For Time Material we find the name of the figure selected
      this.timeMaterialTablesRows[this.selectedRowIndex] = this.formGroupTimeMaterial.value;
      this.timeMaterialTablesRows[this.selectedRowIndex].employee_name = this.employees_list.find((emp) => emp.hash === this.formGroupTimeMaterial.value.employee_hash).complete_name;
      if (!!this.formGroupTimeMaterial.value.figure_id) {
        this.timeMaterialTablesRows[this.selectedRowIndex].figure_name = this.figures_list.find((figure) => figure.id == this.formGroupTimeMaterial.value.figure_id).name;
      }
    }
    //When save is pressed also we calculate the total Deal Amount
    this.calculateTotalDealAmount();
    this._modalService.dismissAll();
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
  }

  //Filter selected employees for the datatable box_2
  fillDataTableEmployeeArray() {
    this.employees_list_datatable = this.employees_list.filter((employee) => this.formGroupDetail.value.employee.includes(employee.hash));
    //if this detail section completed it means the user is comeback in detail section
    if (this.isDetailSectionCompleted) {
      if (this.isTaskDeal) {
        this.taskTablesRows.map((item: any, index: number) => {
          if (item.employee_hash && !this.formGroupDetail.value.employee.includes(item.employee_hash)) {
            //If a user it's been removed we show an alert
            if (this.taskTablesRows.length < 2) {
              this.taskTablesRows.pop();
            } else {
              this.taskTablesRows.splice(index, 1);
              this.taskTablesRows = this.taskTablesRows.filter((i) => i);
            }
            //recalculate total
            this.calculateTotalDealAmount();
            //Alert employee removed
            this.toastService.error(italian.data.ALERT.REMOVED_EMPLOYEE_PRESENT_DATATABLE, italian.data.ALERT.ALERT_TITLE, {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
          }
        });
        //Here we check if a new user it's been added, so we have to push it in the datatable automatically
        if (this.formGroupDetail.value.employee && this.formGroupDetail.value.employee.length > 0) {
          this.formGroupDetail.value.employee.map((item) => {
            const alreadyInDatatable = this.taskTablesRows.find((row) => row.employee_hash === item);
            if (!alreadyInDatatable) {
              this.taskTablesRows.push({
                activity_name: null,
                contract_duration: this.formGroupTask.value.contract_duration ? this.formGroupTask.value.contract_duration : null,
                months_number: this.formGroupTask.value.months_number ? this.formGroupTask.value.months_number : null,
                monthly_canon: null,
                employee_name: item ? this.employees_list.find((emp) => emp.hash === item).complete_name : null,
                employee_hash: item ? item : null,
                daily_rate: null,
                line_amount: null,
                discount: null,
              });
            }
          });
        }
      }
      if (this.isTimeMaterialDeal) {
        this.timeMaterialTablesRows.map((item: any, index: number) => {
          //If a user it's been removed we show an alert
          if (item.employee_hash && !this.formGroupDetail.value.employee.includes(item.employee_hash)) {
            //Check if employee datatable is not present in the formGroup we're going to delete and show an error message
            if (this.timeMaterialTablesRows.length < 2) {
              this.timeMaterialTablesRows.pop();
            } else {
              this.timeMaterialTablesRows.splice(index, 1);
              this.timeMaterialTablesRows = this.timeMaterialTablesRows.filter((i) => i);
            }
            //recalculate total
            this.calculateTotalDealAmount();
            //Alert employee removed
            this.toastService.error(italian.data.ALERT.REMOVED_EMPLOYEE_PRESENT_DATATABLE, italian.data.ALERT.ALERT_TITLE, {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
          }
        });
        //Here we check if a new user it's been added, so we have to push it in the datatable automatically
        if (this.formGroupDetail.value.employee && this.formGroupDetail.value.employee.length > 0) {
          this.formGroupDetail.value.employee.map((item) => {
            const alreadyInDatatable = this.timeMaterialTablesRows.find((row) => row.employee_hash === item);
            if (!alreadyInDatatable) {
              this.timeMaterialTablesRows.push({
                figure_id: null,
                figure_name: null,
                period: this.formGroupTimeMaterial.value.period ? this.formGroupTimeMaterial.value.period : null,
                total_effort: this.formGroupTimeMaterial.value.total_effort ? this.formGroupTimeMaterial.value.total_effort : null,
                daily_rate: null,
                employee_name: item ? this.employees_list.find((emp) => emp.hash === item).complete_name : null,
                employee_hash: item ? item : null,
                line_amount: null,
                discount: null,
              });
            }
          });
        }
      }
    }
  }

  formatMoneyValue(value: any, format: string) {
    value = value.trim();
    if (format === "monthly_canon") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          monthly_canon: this._utilService.addDotsToNumber(value),
        });
        this.calculateLineAmountTask(this.formGroupTask.value.monthly_canon);
      } else {
        this.formGroupTask.patchValue({
          monthly_canon: null,
        });
      }
    }
    if (format === "line_amount") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          line_amount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTask.patchValue({
          line_amount: null,
        });
      }
      if (!this.isTaskDeal && !!value) {
        this.formGroupTimeMaterial.patchValue({
          line_amount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTimeMaterial.patchValue({
          line_amount: null,
        });
      }
    }
    if (format === "daily_rate") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          daily_rate: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTask.patchValue({
          daily_rate: null,
        });
      }
      if (!this.isTaskDeal && !!value) {
        this.formGroupTimeMaterial.patchValue({
          daily_rate: this._utilService.addDotsToNumber(value),
        });
        this.calculateLineAmountTimeMaterial(this.formGroupTimeMaterial.value.total_effort);
      } else {
        this.formGroupTimeMaterial.patchValue({
          daily_rate: null,
        });
      }
    }
    if (format === "discount") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          discount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTask.patchValue({
          discount: null,
        });
      }
      if (!this.isTaskDeal && !!value) {
        this.formGroupTimeMaterial.patchValue({
          discount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTimeMaterial.patchValue({
          discount: null,
        });
      }
    }
  }

  calculateLineAmountTask(value: any) {
    if (!!value) {
      if (!!this.formGroupTask.value.months_number) {
        const total: number = this._utilService.removeDotsFromNumber(value) * this.formGroupTask.value.months_number;
        this.formGroupTask.patchValue({
          line_amount: this._utilService.addDotsToNumber(total),
        });
        this.taskTablesRows.map((item: any) => {
          if (!!item.monthly_canon && !!item.months_number) {
            const totalItem: number = this._utilService.removeDotsFromNumber(item.monthly_canon) * item.months_number;
            item.line_amount = this._utilService.addDotsToNumber(totalItem);
          }
        });
      }
    }
    //Recalculate total when line_amount change
    this.calculateTotalDealAmount();
  }

  calculateLineAmountTimeMaterial(value: any) {
    if (!!value) {
      if (this.formGroupTimeMaterial.value.daily_rate) {
        this.formGroupTimeMaterial.patchValue({
          line_amount: this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.formGroupTimeMaterial.value.daily_rate) * value),
        });
      }
      this.timeMaterialTablesRows.map((item: any) => {
        if (!!item.daily_rate && !!item.total_effort) {
          const totalItem: number = this._utilService.removeDotsFromNumber(item.daily_rate) * item.total_effort;
          item.line_amount = this._utilService.addDotsToNumber(totalItem);
        }
      });
    }
    //Recalculate total when line_amount change
    this.calculateTotalDealAmount();
  }

  //This function calculates the total effort(the total days of the deal Excluding Sunday, Saturday and the italian holidays)
  calculateEffortTimeMaterial() {
    if (this.formGroupDetail.value.start_date && this.formGroupDetail.value.end_date) {
      let totalEffort: number = 0;
      const availableWorkingDays = this._utilService.themeConfiguration.working_days;
      const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
      const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
      const numberOfDays: number = endDate.diff(startDate, "days");
      if (typeof numberOfDays == "number" && numberOfDays > 0) {
        for (let i: number = 0; i <= numberOfDays; i++) {
          const date: string = startDate.clone().add(i, "days").format("YYYY-MM-DD");
          //If is not saturday or sunday or an italian holiday we add a day
          //available_working_days contains the working days if you change these in the options, maybe the not working days will be different
          if (availableWorkingDays.includes(Number(moment(date).format("d")))) {
            if (!this._utilService.isHoliday(date)) {
              totalEffort += 1;
            }
          }
        }
        //If is present a row it means there are already selected the employee
        if (this.timeMaterialTablesRows && this.timeMaterialTablesRows.length > 0) {
          this.timeMaterialTablesRows.map((el) => (el.total_effort = totalEffort));
        }
        this.formGroupTimeMaterial.patchValue({
          total_effort: totalEffort,
        });
      }
      this.calculateLineAmountTimeMaterial(this.formGroupTimeMaterial.value.total_effort);
    }
  }

  //This function calculates the month number e the duration for the type task and the period for Time Material type
  async calculateDifferenceInMonth() {
    this.showErrors = false;
    const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
    const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
    if (this.formGroupDetail.value.start_date && this.formGroupDetail.value.end_date) {
      if (startDate > endDate) {
        this.formGroupDetail.patchValue({
          start_date: null,
          end_date: null,
        });
        this.datePicker.forEach((item: any) => item.clear());
        this.showErrors = true;
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        return false;
      }
      if (this.isTaskDeal) {
        const months_number = Math.round(endDate.diff(startDate, "months", true));

        if (this.taskTablesRows && this.taskTablesRows.length > 0) {
          this.taskTablesRows.map((el: any) => {
            el.months_number = months_number < 1 ? 1 : months_number
            el.contract_duration = moment(this.formGroupDetail.value.start_date).format("MMMYYYY") + " - " + moment(this.formGroupDetail.value.end_date).format("MMMYYYY");
          });
        }
        this.formGroupTask.patchValue({
          months_number: months_number < 1 ? 1 : months_number,
          contract_duration: moment(this.formGroupDetail.value.start_date).format("MMMYYYY") + " - " + moment(this.formGroupDetail.value.end_date).format("MMMYYYY"),
        });
        this.calculateLineAmountTask(this.formGroupTask.value.monthly_canon);
      }
      if (this.isTimeMaterialDeal) {
        if (this.timeMaterialTablesRows && this.timeMaterialTablesRows.length > 0) {
          this.timeMaterialTablesRows.map((el) => (el.period = `${italian.data.FROM} ${startDate.format("DD/MM/YYYY")} ${italian.data.TO} ${endDate.format("DD/MM/YYYY")}`));
        }
        this.formGroupTimeMaterial.patchValue({
          period: `${italian.data.FROM} ${startDate.format("DD/MM/YYYY")} ${italian.data.TO} ${endDate.format("DD/MM/YYYY")}`,
        });
        this.calculateEffortTimeMaterial();
      }
      //Calculate default tranche_number is the difference between start_date and end_date
      this.formGroupDetail.patchValue({
        tranche_number: endDate.diff(startDate, "months") < 1 ? 1 : Math.round(endDate.diff(startDate, "months", true)),
      });
      if (!!this.formGroupDetail.value.billing_frequency) {
        const billing: any = this.billingFrequencyList.find((i: any) => i.id === this.formGroupDetail.value.billing_frequency);
        let tranche: any = this.formGroupDetail.value.tranche_number;
        if (!!tranche) {
          this.formGroupDetail.patchValue({
            tranche_number: Math.round(tranche / billing.other.month_value),
          });
        }
      }
    }
  }

  //Here we calculate the total amount e the total discounted
  calculateTotalDealAmount() {
    //When called we reset the values
    this.isThereDiscount = false;
    this.total_deal = 0;
    this.total_discounted_deal = 0;

    if (this.isTaskDeal) {
      this.taskTablesRows.map((item: any) => {
        //Calculate total
        if (item.line_amount) {
          this.total_deal += this._utilService.removeDotsFromNumber(item.line_amount);
        }
        //Calculate total discounted
        if (item.discount) {
          this.isThereDiscount = true; //We use this variable for showing the Discounted Amount in the box 2
          this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.discount);
        } else {
          //If we don't have the discount in this item, we will calculate the discount amount with the total
          if (item.line_amount) {
            this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.line_amount);
          }
        }
      });
    }
    if (this.isTimeMaterialDeal) {
      this.timeMaterialTablesRows.map((item: any) => {
        //Calculate total
        if (item.line_amount) {
          this.total_deal += this._utilService.removeDotsFromNumber(item.line_amount);
        }
        //Calculate line_amount discounted
        if (item.discount) {
          this.isThereDiscount = true; //We use this variable for showing the Discounted Amount in the box 2
          this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.discount);
        } else {
          //If we don't have the discount in this item, we will calculate the discount amount with the total
          if (item.line_amount) {
            this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.line_amount);
          }
        }
      });
    }
    this.total_deal = this._utilService.addDotsToNumber(this.total_deal);
    this.total_discounted_deal = this._utilService.addDotsToNumber(this.total_discounted_deal);
    //Here we set the total only for the first element of the array(The backend will read this object)
    if (this.isTaskDeal) {
      if (this.taskTablesRows && this.taskTablesRows.length > 0) {
        this.taskTablesRows[0].total_deal = this.total_deal;
        this.taskTablesRows[0].total_discounted_deal = this.total_discounted_deal;
      }
    }
    if (this.isTimeMaterialDeal) {
      if (this.timeMaterialTablesRows && this.timeMaterialTablesRows.length > 0) {
        this.timeMaterialTablesRows[0].total_deal = this.total_deal;
        this.timeMaterialTablesRows[0].total_discounted_deal = this.total_discounted_deal;
      }
    }
  }

  changeReferentList() {
    this.referents_list = this.referents_list.filter((item): any => {
      return item.client_id === this.formGroupDetail.value.customer;
    });
  }

  async onReferentModalFormEvent(ref: any) {
    if (!this._authService.hasCapability("create_customer_referent")) {
      await this.router.navigateByUrl("dashboard/main");
      return false;
    }
    this.referents_list = await this._customerService.getReferents();
    const newReferent: any = this.referents_list.find((referent: any) => Number(referent.id) === Number(ref.id));
    setTimeout(() => {
      this.formGroupDetail.patchValue({
        customer: newReferent.client_id,
      });
      this.changeReferentList();
      this.formGroupDetail.patchValue({
        referent_id: newReferent.id,
      });
    });
  }

  takeDate(event: any, field: string) {
    if (field === "start_date") {
      this.formGroupDetail.patchValue({
        start_date: event,
      });
    }
    if (field === "end_date") {
      this.formGroupDetail.patchValue({
        end_date: event,
      });
    }
  }

  async handlerChangeFileInput(event) {
    if (event[0].size > 10000000) {
      await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
      return false;
    }
    this.fileName = event[0].name;
    this.dealDocument = event;
  }

  async uploadDocument() {
    if (!this._authService.hasCapability("manage_deal_document")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.dealDocument) {
      this._utilService.showLoading();
      await this._dealService
        .uploadDocument(this.dealDocument[0], this.dealId)
        .then(async () => {
          this.completedFileUpload = true;
          await this.loadDeal();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FILE_DOCUMENT" });
        })
        .catch(async () => {
          await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE_DOCUMENT" });
        });
    }
  }

  async edit(redirect: boolean = true) {
    this.showErrors = false;
    if (!this._authService.hasCapability("edit_deal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return { error: true };
    }
    let errorLineAmount: boolean = false;
    //Check date
    const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
    const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
    if (startDate.format("YYYY-MM-DD HH:mm:00") > endDate.format("YYYY-MM-DD HH:mm:00")) {
      this.activeTab = "deal_detail";
      setTimeout(() => {
        document.getElementById("section2").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      await this._utilService.showSWALError({ text: "ERROR_DATE_INSERT" });
      this.showErrors = true;
      return { error: true };
    }
    //Check empty fields
    let keyToShowError: any = [];
    Object.keys(this.formGroupDetail.controls).map((key) => {
      if (this.formGroupDetail.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    Object.keys(this.formGroupBoxes.controls).map((key) => {
      if (this.formGroupBoxes.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    if (this.formGroupDetail?.value?.tranche_number == 0) {
      keyToShowError.push("tranche_number");
    }
    if (this.formGroupDetail.invalid || this.formGroupBoxes.invalid || this.formGroupDetail?.value?.tranche_number == 0) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          if (key.includes("box_")) {
            key = key.replace("box_", italian.data.PARAGRAPH + " ");
          }
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      textMessage += " " + keyToShowError.join(", ");

      this._utilService.showSWALEmptyField({ text: textMessage });
      return { error: true };
    }
    if (this.isTaskDeal) {
      //we control if line_amount has a value and discount if 0 we send it to null
      this.taskTablesRows.map(async (row: any) => {
        if (!row.line_amount) {
          errorLineAmount = true;
        }
      });
    }
    if (this.isTimeMaterialDeal) {
      //we control if line_amount has a value and discount if 0 we send it to null
      this.timeMaterialTablesRows.map(async (row: any) => {
        if (!row.line_amount) {
          errorLineAmount = true;
        }
      });
    }

    if (errorLineAmount) {
      await this._utilService.showSWALError({ text: "ERROR_TOTAL_DEAL" });
      this.showErrors = true;
      return { error: true };
    }
    //End Check empty fields

    this._utilService.showLoading();
    let data: IDeal = {
      deal_type: this.typeDeal,
      client_id: this.formGroupDetail.value.customer,
      site_id: this.formGroupDetail.value.office_site,
      referent_id: this.formGroupDetail.value.referent_id,
      commercial: this.formGroupDetail.value.commercial,
      object: this.formGroupDetail.value.object,
      name: this.formGroupDetail.value.name,
      employees: this.formGroupDetail.value.employee,
      start_date: this.formGroupDetail.value.start_date,
      end_date: this.formGroupDetail.value.end_date,
      billing_frequency: this.formGroupDetail.value.billing_frequency,
      tranche_number: this.formGroupDetail.value.tranche_number,
      deal_document: {
        box_1: this.formGroupBoxes.value.box_1,
        box_2: this.formGroupBoxes.value.box_2,
        box_3: this.formGroupBoxes.value.box_3,
        box_4: this.formGroupBoxes.value.box_4,
        box_5: this.formGroupBoxes.value.box_5,
        box_6: this.formGroupBoxes.value.box_6,
        box_7: this.formGroupBoxes.value.box_7,
        box_8: this.formGroupBoxes.value.box_8,
        table: JSON.stringify(this.isTaskDeal ? this.taskTablesRows.filter((item) => item) : this.timeMaterialTablesRows.filter((item) => item)),
        table_columns: this.isTaskDeal ? this.columnTableTask : this.columnTableTimeMaterial,
      },
    };

    return this._dealService
      .editDeal(this.dealId, data)
      .then(async () => {
        if (redirect) {
          this._utilService.hideLoading();
          await this.router.navigateByUrl("/dashboard/deals/list");
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_DEAL" });
        } else {
          return { error: false };
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_DEAL" });
        return { error: true };
      });
  }

  async regenerateDocument() {
    await this._utilService
      .showSWALDeleteConfirmation({
        text: "ALERT.CONFIRM_REGENERATE_TEXT",
        customClass: { confirmButton: "btn btn-success" },
        confirmButtonText: "CONFIRM_GENERATE_BTN",
      })
      .then(async (result) => {
        if (result.value) {
          this.edit(false).then(async (response: { error: boolean }) => {
            if (!response.error) {
              this._utilService.showLoading();
              await this._dealService
                .generateDealDocument(this.dealId)
                .then(async () => {
                  await this.loadDeal();
                  this._utilService.hideLoading();
                  await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DEAL_DOCUMENT" });
                })
                .catch(async () => {
                  this._utilService.hideLoading();
                  await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
                });
            }
          });
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_GENERATE_TEXT",
          });
        }
      });
  }

  async generateDocument() {
    this.edit(false).then(async (response: { error: boolean }) => {
      if (!response.error) {
        this._utilService.showLoading();
        await this._dealService
          .generateDealDocument(this.dealId)
          .then(async () => {
            await this.loadDeal();
            this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DEAL_DOCUMENT" });
          })
          .catch(async () => {
            this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
          });
      }
    });
  }

  downloadDocument() {
    return this._utilService.downloadPDF(this.deal.deal_document.document_url, this.deal.complete_name.replace("#", ""));
  }

  resetCustomerInformations(customer: ICustomer) {
    this.formGroupDetail.patchValue({
      referent_id: null,
      office_site: null,
    });

    this.filtered_referents_list = this.referents_list.filter((r) => r.client_id === customer.id);
    this.filtered_customers_site_list = this.customers_site_list.filter((s) => s.client && s.client?.id === customer.id);
  }
}
